import React, { FC } from 'react';
import { Redirect, RouteComponentProps, Switch } from 'react-router-dom';
import PruRoute from '../../../../common/components/PruRoute';
import ParamsProvider from '../../../../common/components/ParamsProvider';
import CreditListingPage, { walletCreditFilterKeys } from './List/CreditListingPage';

const WalletCreditRoutes: FC<RouteComponentProps> = ({ match }) => {
  return (
    <Switch>
      <Redirect exact from={match.path} to={`${match.path}/list`} />
      <PruRoute
        exact
        path={`${match.path}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={walletCreditFilterKeys}>
            <CreditListingPage />
          </ParamsProvider>
        )}
      />
    </Switch>
  );
};

export default WalletCreditRoutes;
